// Shared search-submission workflow — the single canonical way any input
// on the site (navbar, homepage Discovery panel, ...) turns typed text
// into a real search. Kept as one function so every entry point stays in
// sync on the query param name (`q`) and encoding, rather than each
// component re-deriving `/search?q=...` on its own.
export function goToSearch(navigate, query) {
  const q = (query || "").trim();
  if (!q) return false;
  navigate(`/search?q=${encodeURIComponent(q)}`);
  return true;
}
